import { render, staticRenderFns } from "./CustomerItem.vue?vue&type=template&id=734618e3&scoped=true"
import script from "./CustomerItem.vue?vue&type=script&lang=js"
export * from "./CustomerItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734618e3",
  null
  
)

export default component.exports